/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type Lead_type = "LIVE_VIEWING" | "QR_CODE" | "%future added value";
export type TourLeadCreateInput = {
    tourId: string;
    name: string;
    surname?: string | null;
    email?: string | null;
    leadType: Lead_type;
    contactNumber?: string | null;
    turnstileToken: string;
};
export type useTourLeadsCaptureMutationVariables = {
    input: TourLeadCreateInput;
};
export type useTourLeadsCaptureMutationResponse = {
    readonly tourLeadCreate: {
        readonly tourLead: {
            readonly id: string;
            readonly name: string;
            readonly surname: string;
            readonly email: string;
            readonly contactNumber: string;
            readonly leadType: Lead_type;
        };
    };
};
export type useTourLeadsCaptureMutation = {
    readonly response: useTourLeadsCaptureMutationResponse;
    readonly variables: useTourLeadsCaptureMutationVariables;
};



/*
mutation useTourLeadsCaptureMutation(
  $input: TourLeadCreateInput!
) {
  tourLeadCreate(input: $input) {
    tourLead {
      id
      name
      surname
      email
      contactNumber
      leadType
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TourLeadCreatePayload",
    "kind": "LinkedField",
    "name": "tourLeadCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TourLead",
        "kind": "LinkedField",
        "name": "tourLead",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "surname",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "leadType",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useTourLeadsCaptureMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTourLeadsCaptureMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "312f2917d24cc979a960cb7a1d4d5e0b",
    "id": null,
    "metadata": {},
    "name": "useTourLeadsCaptureMutation",
    "operationKind": "mutation",
    "text": "mutation useTourLeadsCaptureMutation(\n  $input: TourLeadCreateInput!\n) {\n  tourLeadCreate(input: $input) {\n    tourLead {\n      id\n      name\n      surname\n      email\n      contactNumber\n      leadType\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '76c5e7b9d0138828778b1de411fb6eef';
export default node;
